import { render, staticRenderFns } from "./DedicatedNumberSubscriptionNotification.vue?vue&type=template&id=2e5ae438&scoped=true&"
import script from "./DedicatedNumberSubscriptionNotification.vue?vue&type=script&lang=js&"
export * from "./DedicatedNumberSubscriptionNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5ae438",
  null
  
)

export default component.exports